


import React, { useState, useContext } from "react"
import { Divider, Container, Grid, Radio, FormControlLabel, RadioGroup } from "@material-ui/core"
import {loadStripe} from '@stripe/stripe-js';
import {
  Elements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useElements,
} from '@stripe/react-stripe-js';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import './CreditCard.scss'
import FlexView from "react-flexview/lib";
import { SessionContextStore } from "../../context/SessionContext";
import { EventEmitterService, EventKey } from "../../services/EventEmitterService";
import { awaitWithLoading, isInFlow } from "../../services/utils";
import { UserApi } from "../../api/user.api";
import { BrowserView, MobileView } from "react-device-detect";
import { TextDivider } from "../Core/TextDivier";
import { useLocation } from "react-router-dom";
import { ContinueButton } from "../Core/Buttons/ContinueButton";
import { BackButton } from "../Core/Buttons/BackButton";
import { GreenButton } from "../Core/Buttons/GreenButton";
import { CreditCardLogo } from "../Core/CreditCardLogo";
import { BottomSheetPolicySummary } from '../Insurance/BottomSheetPolicySummary';
import NewFillButton from "../Core/NewFillButton";
import DataLayerService from "../../services/DataLayerService";
import { Experiment, Variant } from "react-optimize";
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from "../../context/InsuracePurchaseContext";
import { PaymentMethod } from "../../models/user-models/CreditCardModal";
import { Action } from "../../models/Action";
import { SessionService } from "../../services/SessionService";
import insuranceApi from "../../api/insurance.api";
import { BuyingInsuranceContextStore } from "../../context/BuyingInsuranceContext";
import CreditCard from "./PaymentMethods/CreditCard";
import PaymentMethods from "./PaymentMethods";
import { PolicyManagementContextStore } from "../../context/PolicyManagementContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
var classNames = require('classnames')

const stripePromiseStarr = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const stripePromiseGlobal = loadStripe(process.env.REACT_APP_STRIPE_KEY_GLOBAL);

export const CheckoutForm = () => {
    const history = useHistory()
    const insuranceContext = useContext(InsurancePurchaseContextStore)
    const offersContext = useContext(BuyingInsuranceContextStore)
    const policyContext = useContext(PolicyManagementContextStore)
    const carrier = policyContext.active_policies.length &&  policyContext.active_policies[0].carrier ==='Starr'? 'Starr':'Global'
    const stripePromise = carrier === 'Starr'? stripePromiseStarr : stripePromiseGlobal;
    
    const location = useLocation()
    
    const onPurchase = async () => {
        if(!isInFlow(location.pathname)) return
        var utm_campaign= localStorage.getItem('utm_campaign')
        var utm_medium= localStorage.getItem('utm_medium')
        var utm_source= localStorage.getItem('utm_source')
        var utm_term= localStorage.getItem('utm_term')
        var utm_content= localStorage.getItem('utm_content')
        let res = await awaitWithLoading(insuranceApi.purchaseInsurance(insuranceContext.selectedOption.offerId,
               insuranceContext.additionalInsuredList,
               insuranceContext.autoRenew,
               insuranceContext.externalUserId,
               insuranceContext.paymentMethod, utm_campaign,
               utm_medium, utm_source,utm_term, utm_content))
        if(res.ok) {
          EventEmitterService.dispatch(EventKey.FLOW_INSURANCE_PURCHASED_SUCCESS, res.parsedData)
        }
        else {
          if(res.data && res.data.messages && res.data.messages.approval_required) {
              EventEmitterService.dispatch(EventKey.ShowError, {res: res, closeBelowAction: true, actionText: 'Refer', onClose: async (btnId) => {
                  if(btnId == 1) {
                      let res2 = await awaitWithLoading(insuranceApi.referQuote(insuranceContext.selectedOption.liabilityLimit,
                          insuranceContext.autoRenew,
                          insuranceContext.additionalInsuredList,
                          insuranceContext.drones,
                          insuranceContext.equipment,
                          insuranceContext.selectedOption.billingPeriod,
                          offersContext.subscriptionStartTime,
                          offersContext.coverageType, 
                          offersContext.operators, 
                          offersContext.maximumUasInAir))
                      if(res2.ok) {
                          EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Refer request sent successfuly'})
                      }
                      else 
                          EventEmitterService.dispatch(EventKey.ShowError, res2)
                  }
              }})
          }
          else {
              if(res.status === 404){
                history.push('/insurance/summary')
              }
              EventEmitterService.dispatch(EventKey.ShowError, res)
          }
        }
      }

    return (
        <React.Fragment>
            <MobileView>
                <div className="margin-top-medium">
                    <TextDivider><div className="text-title bold blue">Payment Details</div></TextDivider>
                </div>
            </MobileView>
            <Container maxWidth="md" className="margin-top-medium">
                <BrowserView>
                    <FlexView className="space-between">
                        <div className="blue text-title">Payment Details</div>
                        <img className="strip-powered" src={`${process.env.PUBLIC_URL}/assets/stripe.png`} />
                    </FlexView>
                    <Divider />
                </BrowserView>
                <MobileView>
                    <FlexView className="space-between">
                        <div className="black text-title margin-bottom-basic">Add credit card</div>
                        <img className="strip-powered" src={`${process.env.PUBLIC_URL}/assets/stripe.png`} />
                    </FlexView>
                </MobileView>
                <Elements stripe={stripePromise}>
                    <PaymentMethods onPurchase={onPurchase} carrier={carrier} />
                </Elements>
            </Container>
        </React.Fragment>
        
    )
}

